import { IMAGE_MODE } from './contentTypes';

export const NO_IMAGE_DEFAULT = (imageMode) => ({
  width: 200,
  height: imageMode === IMAGE_MODE.POSTER ? 300 : 100,
  backgroundColorOne: '#212121',
  backgroundColorTwo: '#303030',
});
